export default __webpack_public_path__ + "media/zurb/img/work/tcl/tcl-interface-fceda7f501b03a7f12850dead1f20c13.png";